import { Button, ButtonProps } from "antd";
import classNames from "classnames";
import "./index.scss";

interface SJProps extends ButtonProps {
  below?: boolean;
}

const SJButton = ({ children, className, below, ...props }: SJProps) => {
  return (
    <Button
      className={classNames("sj-button", below && "below-btn", className)}
      {...props}
    >
      {children}
    </Button>
  );
};

export default SJButton;
